import { ReturnDetails } from "../../../../returns.types";
import { ReturnModalItemsBlock, ReturnModalPricesBlock } from "./blocks";

import styles from "../ReturnModal.module.scss";

export const ReturnContent = ({
  returnDetails
}: {
  returnDetails?: ReturnDetails;
}) => {
  return (
    <div className={styles.returnModal_columns}>
      <ReturnModalPricesBlock returnDetails={returnDetails as ReturnDetails} />
      <ReturnModalItemsBlock returnDetails={returnDetails as ReturnDetails} />
    </div>
  );
};
